// localStorage rather than sessionStorage: magic links open in a new tab, which has its own sessionStorage.
const RETURN_TO_KEY = 'auth:returnTo';

/**
 * Only same-app paths can be returned to, since returnTo comes from the URL and could be crafted to send
 * someone to another site after signing in. /signin is excluded because it would never leave the sign-in page.
 */
const isSafeReturnTo = (path: string | null): path is string =>
  !!path && /^\/(?![/\\])/.test(path) && !/^\/signin(?:[/?#]|$)/i.test(path);

export const signInPathFor = (returnTo: string) => `/signin?returnTo=${encodeURIComponent(returnTo)}`;

export const safeReturnTo = (path: string | null) => (isSafeReturnTo(path) ? path : null);

export const readReturnTo = () => {
  try {
    return safeReturnTo(localStorage.getItem(RETURN_TO_KEY));
  } catch {
    return null;
  }
};

export const clearReturnTo = () => {
  try {
    localStorage.removeItem(RETURN_TO_KEY);
  } catch {
    // Storage is unavailable, so there is nothing to clear
  }
};

export const rememberReturnTo = (path: string) => {
  try {
    localStorage.setItem(RETURN_TO_KEY, path);
  } catch {
    // Storage is unavailable, so the person lands on the default page after signing in
  }
};
